// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"c0c7c833","402":"2a08262c","433":"93202936","774":"3d2925a4","787":"ad090d90"}[chunkId] + ".chunk.js";
};